export default __webpack_public_path__ + "static/media/fi-tag-48.725e646c.svg";